import MapMarkerRCGo from './svg/icon_rcgo.svg';
import MapMarkerBuySell from './svg/icon_buy_sell.svg';
import MapMarkerBuy from './svg/icon_buy.svg';

function rockitcoinMapInit() {
	const blockWrapper = document.querySelector(
		'.wp-block-rockitcoin-atm-locator'
	);

	if (blockWrapper) {
		// Make sure the Google Maps SDK has loaded.
		if (typeof google === 'undefined') {
			return;
		}

		// Set up Google Libraries.
		// Keep linter from crying about undefined google var.
		const googlesdk = google; //eslint-disable-line

		const { Map, Geocoder, LatLng, GeocoderStatus, places, LatLngBounds } =
			googlesdk.maps;

		const { Autocomplete } = places;

		// Get all the necessary elements.
		// Search form.
		const searchForm = blockWrapper.querySelector('.atm-search-form');

		// Location input field.
		const locationInput = searchForm.querySelector('[name=location_input]');

		// Search radius dropdown.
		const searchRadiusInput = searchForm.querySelector(
			'[name=search_radius]'
		);

		// Map element.
		const mapElement = blockWrapper.querySelector('.map-holder');

		// Results listings.
		const resultListingsElement =
			blockWrapper.querySelector('.result-listings');

		const browserLocationButton = blockWrapper.querySelector(
			'.browser-location-button'
		);

		const resultsCountElement =
			blockWrapper.querySelector('.results-count');

		const noResultsMessage = blockWrapper.querySelector(
			'.no-locations-message'
		);

		// Clear the custom validity message when the location input changes.
		['change', 'keyup'].forEach((event) => {
			locationInput.addEventListener(event, () => {
				locationInput.setCustomValidity('');
			});
		});

		// Search form submit.
		searchForm?.addEventListener('submit', function (e) {
			e.preventDefault();

			if (placeSelected) {
				getLocations();
			} else {
				locationInput.setCustomValidity(
					'Please choose a location from the dropdown.'
				);
				locationInput.reportValidity();
			}
		});

		browserLocationButton?.addEventListener('click', () => {
			enableBrowserLocation();
		});

		const geocoder = new Geocoder();
		let userLat,
			userLng,
			userSearch,
			placeSelected = false;

		// Get user's location from browser.
		const enableBrowserLocation = () => {
			if (window.navigator.geolocation) {
				window.navigator.geolocation.getCurrentPosition(
					(location) => {
						userLat = location.coords.latitude;
						userLng = location.coords.longitude;
						userSearch = '';

						// Get location from coords.
						const latlng = new LatLng(userLat, userLng);
						geocoder.geocode(
							{
								latLng: latlng,
							},
							function (resultPlaces, status) {
								if (status === GeocoderStatus.OK) {
									userSearch =
										resultPlaces[0].formatted_address;
									locationInput.value = userSearch;
								}
							}
						);
					},
					(error) => {
						console.error('Error receiving location', error);
						// eslint-disable-next-line no-alert
						alert(
							'Browser location unavaible. Please check your browser settings.'
						);
					}
				);
			}
		};

		const autocomplete = new Autocomplete(locationInput);
		autocomplete.addListener('place_changed', () => {
			const place = autocomplete.getPlace();

			userLat = place.geometry.location.lat();
			userLng = place.geometry.location.lng();

			userSearch = place.formatted_address;

			// Enlarge the search radius for locations without a city.
			const hasCity = locationHasCity(place);
			if (!hasCity) {
				searchRadiusInput.value = 300;
			}

			placeSelected = true;

			searchForm
				.querySelector("[type='submit']")
				.removeAttribute('disabled');
		});

		const locationHasCity = (location) => {
			let hasCity = false;
			location?.address_components?.forEach((component) => {
				component?.types?.forEach((type) => {
					if ('administrative_area_level_2' === type) {
						hasCity = true;
					}
				});
			});
			return hasCity;
		};

		let locations, locationsFiltered;

		const getLocations = () => {
			// Convert distance to meters.
			const distance = parseInt(searchRadiusInput.value) * 1609.34;

			const params = {
				latitude: userLat,
				longitude: userLng,
				show2Way: false,
				showRcGo: true,
				radiusInM: distance,
			};

			blockWrapper.classList.add('loading');
			resultsCountElement.innerHTML = `Searching for locations...`;

			// Convert params object to query string
			const queryString = new URLSearchParams(params).toString();

			// Append the query string to the URL
			const url =
				'https://us-central1-rockitcoin-data-development.cloudfunctions.net/rockitcoin-getLocationsHttps?' +
				queryString;

			fetch(url)
				.then((response) => {
					if (!response.ok) {
						throw new Error('Network response was not ok');
					}
					return response.json();
				})
				.then((data) => {
					locations = data?.locations;
					parseLocations();
					filterLocations();
					blockWrapper.classList.remove('loading');
				})
				.catch((error) => {
					// Handle any errors that occurred during the fetch
					console.error('Fetch error:', error);
					blockWrapper.classList.remove('loading');
				});
		};

		const parseLocations = () => {
			// Build an array of the buy/sell currencies for the location.
			locations.forEach((location) => {
				location.buyCurrencies = [];
				location.sellCurrencies = [];

				if (location.crypto?.length) {
					location.crypto.forEach((currency) => {
						if (parseInt(currency.buy)) {
							location.buyCurrencies.push(currency.code);
						}
						if (parseInt(currency.sell)) {
							location.sellCurrencies.push(currency.code);
						}
					});
				}

				//Sanitize the location ID.
				location.id = location.id.replace(/[^a-z0-9]/gi, '');
			});
		};

		const filterLocations = () => {
			// Filter by location type.
			const locationTypeFilter = searchForm.querySelector(
				'[name=location_type]:checked'
			).value;

			locationsFiltered = [];

			locations.forEach((location) => {
				const locationType = getLocationType(location);

				// Add the location type class.
				location.type = locationType;

				if ('rcgo' === locationType) {
					// RC Go Locations.
					if ('rockitcoin_go' === locationTypeFilter) {
						locationsFiltered.push(location);
					}
				} else {
					// All ATMs.
					// eslint-disable-next-line no-lonely-if
					if ('all' === locationTypeFilter) {
						locationsFiltered.push(location);

						// Buy & Sell ATMs.
					} else if (
						'buy_and_sell' === locationTypeFilter &&
						'buy_and_sell' === locationType
					) {
						locationsFiltered.push(location);

						// Buy only ATMs.
					} else if (
						'buy' === locationTypeFilter &&
						'buy' === locationType
					) {
						locationsFiltered.push(location);
					}
				}
			});

			sortLocations();
		};

		/**
		 * Sorts the locations by distance.
		 */
		const sortLocations = () => {
			locationsFiltered.forEach((location) => {
				location.distance = getLocationDistance(
					location.latitude,
					location.longitude
				);
			});

			locationsFiltered.sort((a, b) => a.distance - b.distance);

			displayLocations();
		};

		/**
		 * Accepts a location object and returns the location type.
		 *
		 * @param {Object} location - The location object.
		 * @return {string} - rcgo, buy_and_sell, or buy.
		 */
		const getLocationType = (location) => {
			const locationType = location.locationType;
			const locationCanBuy = location.buyCurrencies.length;
			const locationCanSell = location.sellCurrencies.length;
			const locationCanBuySell = locationCanBuy && locationCanSell;

			if ('RCGo' === locationType) {
				return 'rcgo';
			} else if (locationCanBuySell) {
				return 'buy_and_sell';
			} else if (locationCanBuy && !locationCanSell) {
				return 'buy';
			}
			return '';
		};

		const getLocationPostInfo = (currentID) => {

			let wpPostFetch = '/wp-json/wp/v2/location?location_atm_id_number=' + currentID;
			fetch(wpPostFetch)
				.then(response => {
					if (!response.ok) {
					throw new Error('Network response was not ok');
					}
					return response.json();
				})
				.then(data => {
					if(data.length !== 0) {
						document.getElementById("wp-link-"+currentID).innerHTML = '<a href="' + data[0]['link'] + '">Location Details</a>';
					}
				})
				.catch(error => {
					console.error('Error:', error);
				});
		};

		const displayLocations = () => {
			if (locationsFiltered.length) {
				resultListingsElement.innerHTML = '';
				resultListingsElement.scrollTop = 0;
				noResultsMessage.style.display = 'none';
				resultsCountElement.style.display = 'block';

				clearMarkers();

				getLocationPostInfo();

				locationsFiltered.forEach((location) => {
					addLocationListing(location);
					addMapMarker(location);
				});

				initLocationListeners();
				zoomToFitMarkers();
				updateResultsCount();

				blockWrapper.classList.remove('loading');
				blockWrapper.classList.remove('no-location');
			} else {
				blockWrapper.classList.add('no-location');
				noResultsMessage.style.display = 'flex';
				resultsCountElement.style.display = 'none';
			}
		};

		const addLocationListing = (location) => {
			let thisLocation = `<div class="location location-type-${location.type}" data-location-id="${location.id}">`;
			thisLocation += `<div class="info">`;
			thisLocation += `<button class="location-button">`;
			thisLocation += location.name;

			if ('RCGo' === location.locationType) {
				thisLocation += `<span class="rc-go-location"> - RockItCoin Go</span>`;
			}

			thisLocation += `<span class="distance">${location.distance} mi.</span>`;

			thisLocation += `</button>`;
			thisLocation += `<div class="meta address">${location.address}</div>`;

			if ('hours' in location && location.hours.length) {
				thisLocation += `<div class="meta hours">${location.hours}</div>`;
			}
			thisLocation += `<div class="meta phone"><a href="tel:18887024826">1-888-702-4826</a></div>`;

			thisLocation += `<div class="meta buy-sell">`;

			if (location.buyCurrencies.length) {
				thisLocation += `<div class="currency buy">Buy</div>`;
			}
			if (location.sellCurrencies.length) {
				thisLocation += `<div class="currency sell">Sell</div>`;
			}

			thisLocation += `</div>`;

			thisLocation += `<div class="meta directions"><a href="https://maps.google.com/?saddr=Current+Location&daddr=${location.latitude},${location.longitude}" target="_blank">Get Directions</a></div>`;

			thisLocation += `<div id="wp-link-${location.id}" class="meta location-post"></div>`;

			getLocationPostInfo(location.id);

			thisLocation += `</div>`;

			resultListingsElement.insertAdjacentHTML('beforeend', thisLocation);
		};

		const myLatlng = new LatLng(37.09024, -95.712891);
		const mapOptions = {
			zoom: 4,
			center: myLatlng,
			mapId: 'atm_map',
		};
		const map = new Map(mapElement, mapOptions);

		let mapMarkers = [];
		let mapBounds = [];

		const addMapMarker = (location) => {
			const markerLatLng = new LatLng(
				location.latitude,
				location.longitude
			);

			const mapIcon = document.createElement('img');

			if ('rcgo' === location.type) {
				mapIcon.src = MapMarkerRCGo;
			} else if ('buy_and_sell' === location.type) {
				mapIcon.src = MapMarkerBuySell;
			} else if ('buy' === location.type) {
				mapIcon.src = MapMarkerBuy;
			}

			mapIcon.dataset.locationid = location.id;

			const locationMarker =
				new googlesdk.maps.marker.AdvancedMarkerElement({
					position: markerLatLng,
					map,
					title: location.name,
					content: mapIcon,
				});

			locationMarker.setMap(map);

			locationMarker.addListener('click', ({ domEvent }) => {
				showLocationDetails(domEvent.target.dataset.locationid, true);
			});

			mapMarkers.push(locationMarker);
			mapBounds.push(markerLatLng);
		};

		const clearMarkers = () => {
			if (mapMarkers.length) {
				mapMarkers.forEach((mapMarker) => {
					mapMarker.setMap(null);
				});

				mapMarkers = [];
				mapBounds = [];
			}
		};

		const zoomToFitMarkers = () => {
			const bounds = new LatLngBounds();
			mapBounds.forEach((bound) => {
				bounds.extend(bound);
			});
			map.fitBounds(bounds);
		};

		const updateResultsCount = () => {
			if (locationsFiltered.length) {
				resultsCountElement.innerHTML = `Showing ${locationsFiltered.length} locations.`;
				resultsCountElement.style.display = 'block';
			} else {
				resultsCountElement.style.display = 'none';
			}
		};

		const initLocationListeners = () => {
			const locationButtons =
				blockWrapper.querySelectorAll('.location-button');
			locationButtons.forEach((button) => {
				button.addEventListener('click', () => {
					const locationId =
						button.closest('.location').dataset.locationId;
					showLocationDetails(locationId, true);
				});
			});
		};

		const showLocationDetails = (locationId, scrollToLocation = false) => {
			const thisLocation = getLocationById(locationId);

			const markerLatLng = new LatLng(
				thisLocation.latitude,
				thisLocation.longitude
			);

			map.panTo(markerLatLng);
			map.setZoom(14);

			blockWrapper
				.querySelector('.location.active')
				?.classList.remove('active');

			const activeLocation = blockWrapper.querySelector(
				`.location[data-location-id='${locationId}']`
			);

			activeLocation?.classList.add('active');

			if (scrollToLocation) {
				const topDistance =
					activeLocation.getBoundingClientRect().top -
					resultListingsElement.getBoundingClientRect().top +
					resultListingsElement.scrollTop;

				resultListingsElement.scrollTo({
					top: topDistance,
					behavior: 'smooth',
				});
			}

			// If mobile, scroll to map.
			if (window.innerWidth < 1024) {
				const blockTop =
					blockWrapper.getBoundingClientRect().top +
					window.scrollY -
					30;

				window.scrollTo({
					top: blockTop,
					behavior: 'smooth',
				});
			}
		};

		// Find the selected location in the locations array.
		const getLocationById = (locationId) => {
			let locationMatch;
			locationsFiltered.forEach((location) => {
				if (location.id === locationId) {
					locationMatch = location;
				}
			});
			return locationMatch;
		};

		// Calculates a user's distance from the current user.
		function getLocationDistance(locationLat, locationLng) {
			function toRad(x) {
				return (x * Math.PI) / 180;
			}

			const R = 6371; // km

			const x1 = userLat - locationLat;
			const dLat = toRad(x1);
			const x2 = userLng - locationLng;
			const dLon = toRad(x2);
			const a =
				Math.sin(dLat / 2) * Math.sin(dLat / 2) +
				Math.cos(toRad(locationLat)) *
					Math.cos(toRad(userLat)) *
					Math.sin(dLon / 2) *
					Math.sin(dLon / 2);
			const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
			let d = R * c;

			// Convert to miles.
			d /= 1.60934;

			return Math.round(d);
		}

		// Check for form settings in the URL.
		const urlParams = new URLSearchParams(window.location.search);
		if (
			urlParams.has('lat') &&
			urlParams.has('lng') &&
			urlParams.has('search')
		) {
			userLat = urlParams.get('lat');
			userLng = urlParams.get('lng');
			userSearch = urlParams.get('search');

			const searchRadius = urlParams.get('radius');
			if (searchRadius) {
				searchRadiusInput.value = searchRadius;
			}

			placeSelected = true;

			searchForm
				.querySelector("[type='submit']")
				.removeAttribute('disabled');

			locationInput.value = userSearch;
			getLocations();
		}

		if (urlParams.has('location_type')) {
			const locationTypeCheckbox = searchForm?.querySelector(
				`[name=location_type][value=${urlParams.get('location_type')}]`
			);
			if (locationTypeCheckbox) {
				locationTypeCheckbox.checked = true;
			}
		}
	}
}

window.rockitcoinMapInit = rockitcoinMapInit;

// Load the maps SDK.
const script = document.createElement('script');
script.src =
	'https://maps.googleapis.com/maps/api/js?key=AIzaSyCcwblzAhzim-6nEZjEJ8bQ-eXiAH1Uhvs&libraries=places,marker&loading=async&callback=rockitcoinMapInit';
script.type = 'text/javascript';
script.async = true;
document.head.appendChild(script);